import React from 'react';
import toLower from 'lodash/toLower';

import { useTranslation } from '@lyearn/i18n';
import { LockOutline } from '@lyearn/icons';
import { cn } from '@lyearn/style';
import { Button, Stack, Typography } from '@lyearn/ui';
import useNavigation from '@/hooks/useNavigation';

import { actionLabelMap, subjectLabelMap } from '../../WorkspaceAccessControl/utils';
import { textContainerStyles } from './styles';
import { Error403Props } from './types';

function Error403({ action, resource, subject, showBackButton }: Error403Props) {
  const { t } = useTranslation();
  const navigation = useNavigation();
  const actionLabel = action ? toLower(actionLabelMap[action]) : 'access';
  const subjectLabel = subject ? toLower(subjectLabelMap[subject]) : resource;

  return (
    <Stack
      alignItems="center"
      className="h-full w-full flex-1"
      direction="col"
      justifyContent="center">
      <LockOutline className="mb-16 h-32 w-32" fillColorToken="icon-placeholder" />
      <Typography
        className={cn('text-center', textContainerStyles)}
        color="text-text-placeholder"
        variant="label-01">
        {t('Common:YouDontHavePermission', {
          action: actionLabel,
          subject: subjectLabel,
        })}
      </Typography>
      {showBackButton ? (
        <Button
          appearance="secondary"
          className="mt-24"
          variant="outlined"
          onClick={navigation.back}>
          {t('Common:Actions.GoBack')}
        </Button>
      ) : null}
    </Stack>
  );
}

export default Error403;
